import cx from 'classnames'
import { useNavItemContext } from '../NavItemContext'
import Styles from './ControlGroup.module.scss'

import { ControlGroupProps } from './Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const ControlGroup = ({ children }: ControlGroupProps) => {
  const { isHovered } = useNavItemContext()
  const { isMobileMd } = useResponsiveDesign()

  return <div className={cx(Styles.controlGroup, { [Styles.hidden]: !isHovered && !isMobileMd })}>{children}</div>
}

export { ControlGroup }
